export const HISTORY_SCOPES = [
  { value: "all", labelKey: "ticketAiAnalysis.historyScope.all" },
  { value: "week", labelKey: "ticketAiAnalysis.historyScope.week" },
  { value: "month", labelKey: "ticketAiAnalysis.historyScope.month" },
  { value: "last_50", labelKey: "ticketAiAnalysis.historyScope.last_50" },
  { value: "last_100", labelKey: "ticketAiAnalysis.historyScope.last_100" },
  { value: "last_200", labelKey: "ticketAiAnalysis.historyScope.last_200" },
];

export const DEFAULT_HISTORY_SCOPE = "week";

export const VALID_HISTORY_SCOPES = HISTORY_SCOPES.map((item) => item.value);

export const getHistoryScopeStorageKey = (companyId) =>
  `chatAgentHistoryScope_${companyId}`;

export const loadHistoryScope = (companyId) => {
  if (!companyId) return DEFAULT_HISTORY_SCOPE;
  const stored = localStorage.getItem(getHistoryScopeStorageKey(companyId));
  return VALID_HISTORY_SCOPES.includes(stored) ? stored : DEFAULT_HISTORY_SCOPE;
};

export const saveHistoryScope = (companyId, scope) => {
  if (!companyId || !VALID_HISTORY_SCOPES.includes(scope)) return;
  localStorage.setItem(getHistoryScopeStorageKey(companyId), scope);
};

export const getHistoryScopeLabel = (scope) => {
  const item = HISTORY_SCOPES.find((entry) => entry.value === scope);
  return item ? item.labelKey : "ticketAiAnalysis.historyScope.week";
};
